import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { FaCheck } from 'react-icons/fa'
import { BsDot } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'

import CustomButton from '../../../component/CustomButton'
import { filterIcon } from '../../../component/helpers/iconHelpers'
import { isInternalUser } from '../../../component/helpers/constants'
import { isCustomUserPermissions } from '../../../component/helpers/helperUsers'

import '../../../component/FilterMenu.sass'
import { getCustomDV7Access, getDV7Access, isDV7TestingVisible } from '../../../component/helpers/helperDV7Access';
// TODO: needs to develop universal filter menu for events
const VehicleSidebarFilter = (props) => {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'homePage.vehicleSidebar.vehicleSidebarFilter' });
    const { user, filters, setFiltersVehiclePanel, userRole, isDV7 } = props
    const userPermissions = user.permissions
    const canEventFeedbackView = !['custom_user', 'custom_partner'].includes(userRole)
        || (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_add'))
        || (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_edit'))

    let countSelectedFilters = canEventFeedbackView ? 0 : 1
    let showFilterActive = false
    for (let [filter, value] of Object.entries(filters)) {
        value && countSelectedFilters++
        if (!['pending', 'feedback'].includes(filter) && !value) {
            showFilterActive = true
        }
    }

    const DV7access = getDV7Access(props.company);
    const customDV7Access = getCustomDV7Access(props.company);

    const onFilterItemClick = (name) => {
        const newFilters = { ...filters }
        newFilters[name] = !newFilters[name]

        setFiltersVehiclePanel(newFilters)
    }

    const selectAllFilters = () => {
        const newFilters = { ...filters }

        if (countSelectedFilters === Object.keys(filters).length) {
            for (let key in newFilters) {
                newFilters[key] = false
            }
        }
        else {
            for (let key in newFilters) {
                if (key === 'feedback' && !canEventFeedbackView) {
                    newFilters[key] = false
                }
                else {
                    newFilters[key] = true
                }
            }
        }
        setFiltersVehiclePanel(newFilters)
    }

    // const { filters, setFiltersVehiclePanel } = props
    // const countSelectedEventTypes = Object.keys(filters.event_types).reduce((sum, value) => (filters.event_types[value] ? sum + 1 : sum), 0)
    // const countSelectedStatuses = Object.keys(filters.statuses).reduce((sum, value) => (filters.statuses[value] ? sum + 1 : sum), 0)
    // const showFilterActive = countSelectedEventTypes !== Object.keys(filters.event_types).length || countSelectedStatuses !== Object.keys(filters.statuses).length

    // const onSelectAllFiltersClick = (filterType) => {
    //     const newFilters = { ...filters }
    //     const countSelected = filterType === 'event_types' ? countSelectedEventTypes : countSelectedStatuses
    //     if (countSelected === Object.keys(newFilters[filterType]).length) {
    //         for (let key in newFilters[filterType]) {
    //             newFilters[filterType][key] = false
    //         }
    //         setFiltersVehiclePanel(newFilters)
    //     } else {
    //         for (let key in newFilters[filterType]) {
    //             newFilters[filterType][key] = true
    //         }
    //         setFiltersVehiclePanel(newFilters)
    //     }
    // }
    // const onFilterItemClick = (filterType, filterItem) => {
    // 	const newFilters = { ...filters }
    //     if ( filterType === 'event_types') {
    //         const obj = newFilters.event_types.find(({fulltype}) => filterItem)
    //         if (obj) {
    //             obj.checked = !obj.checked
    //         }
    //     }
    //     //* filterType === 'statuses')
    //     else {
    // 	    newFilters[filterType][filterItem] = !newFilters[filterType][filterItem]
    //     }

    //     setFiltersVehiclePanel(newFilters)
    // }

    return (
        <Dropdown
            id="type-filter-btn"
            align="start"
            drop
        >
            <Dropdown.Toggle
                // nocaret
                bsPrefix="no-caret event-filter-toggle"
            >
                {filterIcon}
                {showFilterActive
                    && <BsDot className='filter-dot' />
                }
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="typeFilterMenu"
            >
                <h5 className="category-title">{t('titleEvents')}</h5>
                <CustomButton
                    variant="link"
                    prefix="btn-select-all"
                    onClick={selectAllFilters}
                // variant="link"
                // onClick={() => onSelectAllFiltersClick('event_types')}
                >
                    {`${countSelectedFilters === Object.keys(filters).length ? t('unselect') : t('select')} ${t('all')}`}
                </CustomButton>
                <ul className="filters-list">
                    <li onClick={() => onFilterItemClick('critical_gsensor')}>
                        {i18n.t('constants.eventNames.High_G-Force')}
                        {filters.critical_gsensor && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('speed')}>
                        {i18n.t('constants.eventNames.Speeding')}
                        {filters.speed && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('driver')}>
                        {i18n.t('constants.eventNames.Driver')}
                        {filters.driver && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('custom')}>
                        {t('custom')}
                        {filters.custom && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('harshaccel')}>
                        {i18n.t('constants.eventNames.Harsh_Acceleration')}
                        {filters.harshaccel && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('harshbraking')}>
                        {i18n.t('constants.eventNames.Harsh_Braking')}
                        {filters.harshbraking && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('pending')}>
                        {t('Pending')}
                        {filters.pending && <FaCheck className='flagSelected' />}
                    </li>
                    {canEventFeedbackView &&
                        <li onClick={() => onFilterItemClick('feedback')}>
                            {i18n.t('constants.eventNames.Feedback')}
                            {filters.feedback && <FaCheck className='flagSelected' />}
                        </li>
                    }
                    <li onClick={() => onFilterItemClick('reviewed')}>
                        {i18n.t('constants.eventNames.Reviewed')}
                        {filters.reviewed && <FaCheck className='flagSelected' />}
                    </li>
                    {DV7access && (<>
                        {!customDV7Access &&
                            <li onClick={() => onFilterItemClick('gsensor_wakeup')}>
                                {i18n.t('constants.eventNames.G-Sensor_Wake-Up')}
                                {filters.gsensor_wakeup && <FaCheck className='flagSelected' />}
                            </li>
                        }
                        {!customDV7Access &&
                            <li onClick={() => onFilterItemClick('backup_warning')}>
                                {i18n.t('constants.eventNames.Dangerous_Backing-Up_Alerts')}
                                {filters.backup_warning && <FaCheck className='flagSelected' />}
                            </li>
                        }
                        {!customDV7Access &&
                            <li onClick={() => onFilterItemClick('blind_spot_warning_standard')}>
                                {i18n.t('constants.eventNames.Standard_Blind_Spot_Detection_Warning')}
                                {filters.blind_spot_warning_standard && <FaCheck className='flagSelected' />}
                            </li>
                        }
                        {!customDV7Access &&
                            <li onClick={() => onFilterItemClick('blind_spot_warning_urban')}>
                                {i18n.t('constants.eventNames.Urban_Blind_Spot_Detection_Warning')}
                                {filters.blind_spot_warning_urban && <FaCheck className='flagSelected' />}
                            </li>
                        }
                        <li onClick={() => onFilterItemClick('low_speeding')}>
                            {i18n.t('constants.eventNames.Blind_Spot_Detection_Warning_Low')}
                            {filters.low_speeding && <FaCheck className='flagSelected' />}
                        </li>
                        <li onClick={() => onFilterItemClick('moderate_speeding')}>
                            {i18n.t('constants.eventNames.Blind_Spot_Detection_Warning_Moderate')}
                            {filters.moderate_speeding && <FaCheck className='flagSelected' />}
                        </li>
                        <li onClick={() => onFilterItemClick('high_speeding')}>
                            {i18n.t('constants.eventNames.Blind_Spot_Detection_Warning_High')}
                            {filters.high_speeding && <FaCheck className='flagSelected' />}
                        </li>
                        <li onClick={() => onFilterItemClick('severe_speeding')}>
                            {i18n.t('constants.eventNames.Blind_Spot_Detection_Warning_Severe')}
                            {filters.severe_speeding && <FaCheck className='flagSelected' />}
                        </li>
                    </>)}

                    <h5 className="category-subtitle">{t('titleDMS')}</h5>
                    <li onClick={() => onFilterItemClick('distraction')}>
                        {i18n.t('constants.eventNames.Distraction')}
                        {filters.distraction && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('drowsiness')}>
                        {i18n.t('constants.eventNames.Drowsiness/Head_Down')}
                        {filters.drowsiness && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('yawning')}>
                        {i18n.t('constants.eventNames.Yawning')}
                        {filters.yawning && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('phone_use')}>
                        {i18n.t('constants.eventNames.Phone_Use/Hand_to_Head')}
                        {filters.phone_use && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('seatbelt')}>
                        {i18n.t('constants.eventNames.Seatbelt')}
                        {filters.seatbelt && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('smoking')}>
                        {i18n.t('constants.eventNames.Smoking')}
                        {filters.smoking && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('camerablock')}>
                        {i18n.t('constants.eventNames.Potential_Ch2_Obstruction')}
                        {filters.camerablock && <FaCheck className='flagSelected' />}
                    </li>

                    <h5 className="category-subtitle">{t('titleADAS')}</h5>

                    {!(customDV7Access && isDV7) &&
                        <li onClick={() => onFilterItemClick('adas_ldw')}>
                            {i18n.t('constants.eventNames.Lane_Departure')}
                            {filters.adas_ldw && <FaCheck className='flagSelected' />}
                        </li>
                    }
                    {!customDV7Access &&
                        <li onClick={() => onFilterItemClick('adas_pcw')}>
                            {i18n.t('constants.eventNames.Pedestrian_Warning')}
                            {filters.adas_pcw && <FaCheck className='flagSelected' />}
                        </li>
                    }
                    <li onClick={() => onFilterItemClick('adas_fcw')}>
                        {i18n.t('constants.eventNames.Forward_Collision')}
                        {filters.adas_fcw && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('adas_hw')}>
                        {i18n.t('constants.eventNames.Headway_Warning')}
                        {filters.adas_hw && <FaCheck className='flagSelected' />}
                    </li>
                    <li onClick={() => onFilterItemClick('tailgating')}>
                        {i18n.t('constants.eventNames.Tailgating')}
                        {filters.tailgating && <FaCheck className='flagSelected' />}
                    </li>
                    {DV7access && (<>
                        {!customDV7Access &&
                            <li onClick={() => onFilterItemClick('front_vehicle_start')}>
                                {i18n.t('constants.eventNames.Front_Vehicle_Start_Alert')}
                                {filters.front_vehicle_start && <FaCheck className='flagSelected'/>}
                            </li>
                        }
                        {isDV7TestingVisible(customDV7Access) &&
                            <li onClick={() => onFilterItemClick('trafficlightviolation_saw')}>
                                {i18n.t('constants.eventNames.Signal_Approach')}
                                {filters.trafficlightviolation_saw && <FaCheck className='flagSelected'/>}
                            </li>
                        }
                        {isDV7TestingVisible(customDV7Access) &&
                            <li onClick={() => onFilterItemClick('trafficlightviolation_svw')}>
                                {i18n.t('constants.eventNames.Signal_Violation')}
                                {filters.trafficlightviolation_svw && <FaCheck className='flagSelected'/>}
                            </li>
                        }
                        <li onClick={() => onFilterItemClick('stopsignviolation_rsw')}>
                            {i18n.t('constants.eventNames.Rolling_Stop')}
                            {filters.stopsignviolation_rsw && <FaCheck className='flagSelected'/>}
                        </li>
                        <li onClick={() => onFilterItemClick('stopsignviolation_bsw')}>
                            {i18n.t('constants.eventNames.Bypass_Stop')}
                            {filters.stopsignviolation_bsw && <FaCheck className='flagSelected'/>}
                        </li>
                    </>)}
                    {isInternalUser(userRole) && (
                        <>
                            <h5 className="category-subtitle">{t('titleVideoStatus')}</h5>

                            <li onClick={() => onFilterItemClick('videouploaded')}>
                                {t('Uploaded')}
                                {filters.videouploaded && <FaCheck className='flagSelected'/>}
                            </li>
                            <li onClick={() => onFilterItemClick('videopending')}>
                                {t('Pending')}
                                {filters.videopending && <FaCheck className='flagSelected'/>}
                            </li>
                            <li onClick={() => onFilterItemClick('videononexist')}>
                                {t('No_Video_On_Device')}
                                {filters.videononexist && <FaCheck className='flagSelected' />}
                            </li>
                            <li onClick={() => onFilterItemClick('videoconvertedfailed')}>
                                {t('Conversion_Error')}
                                {filters.videoconvertedfailed && <FaCheck className='flagSelected' />}
                            </li>
                            <li onClick={() => onFilterItemClick('videotransferringfailed')}>
                                {t('Download_Error')}
                                {filters.videotransferringfailed && <FaCheck className='flagSelected' />}
                            </li>
                            <li onClick={() => onFilterItemClick('videofilesconverted')}>
                                {t('Files_Converted')}
                                {filters.videofilesconverted && <FaCheck className='flagSelected' />}
                            </li>
                            <li onClick={() => onFilterItemClick('videofailed')}>
                                {t('Event_Failed')}
                                {filters.videofailed && <FaCheck className='flagSelected' />}
                            </li>
                            <li onClick={() => onFilterItemClick('videoundefined')}>
                                {t('Unknown')}
                                {filters.videoundefined && <FaCheck className='flagSelected' />}
                            </li>
                        </>
                    )}
                </ul>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default VehicleSidebarFilter;
